import React from 'react'

import { Icon } from 'src/chrome'

import styles from './planContentsGrid.module.scss'

const PlanContentsGrid: React.FC = props => {
  return (
    <div className={`${styles.featureGridContainer} ${styles.offWhite}`}>
      <div className={styles.featureGrid}>
        <h1>All Card Types:</h1>
        <div className={styles.featureRow}>
          <div className={styles.feature}>
            <div className={styles.featureIcon}>
              <Icon
                icon={'CATALOGCARD'}
                color={'#9C9CA0'}
                viewBox={'0 0 32 32'}
                size={50}
              />
            </div>
            <div className={styles.featureCopy}>
              <h5>Catalog Cards</h5>
              <p>
                Our card catalog features thousands of beautiful designs in
                numerous categories.
              </p>
            </div>
          </div>
          <div className={styles.feature}>
            <div className={styles.featureIcon}>
              <Icon
                icon={'PHOTODROP'}
                color={'#9C9CA0'}
                viewBox={'0 0 19 32'}
                size={50}
              />
            </div>
            <div className={styles.featureCopy}>
              <h5>Photo Drop Cards</h5>
              <p>
                These cards feature beautifully designed templates that you can
                drop your own photos into.
              </p>
            </div>
          </div>
          <div className={styles.feature}>
            <div className={styles.featureIcon}>
              <Icon
                icon={'TEMPLATES'}
                stroke={'#9C9CA0'}
                color={'none'}
                strokeWidth={'46.5455'}
                viewBox={'0 0 838 1024'}
                size={35}
              />
            </div>
            <div className={styles.featureCopy}>
              <h5>Build Your Own Cards</h5>
              <p>
                Add your own pictures, headlines, and text on the front, inside,
                and back panels.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PlanContentsGrid
